import FoodMenus from './foodMenus'

export default FoodMenus